import React from 'react';
import styled from 'styled-components';
import { DynamicLink } from 'packages/smart-home-support/components';
import { NavItem } from 'packages/smart-home-support/assets/models';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import { FooterProps } from '../models';
import Copyright from '../Copyright';
import { legal as legalNavItems } from '../data/navItems';

const FooterContainer = styled.div`
  color: #1b1b1b;
  height: 90px;
  box-shadow: 4px 0px 13px rgba(48, 48, 48, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;

  @media ${BREAK_POINTS.desktop} {
    margin-top: 0;
    height: 65px;
  }
`;

const FooterContentContainer = styled.div`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${BREAK_POINTS.desktop} {
    max-width: none;
    width: 100%;
    display: inline-block;
    padding: 0 20px;
  }
`;

const FooterRow = styled.div`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
  display: flex;
  align-self: center;

  @media ${BREAK_POINTS.desktop} {
    float: right;
    &:first-child {
      float: left;
    }
  }
`;

const Link = styled(DynamicLink)`
  font-size: 12px;
  font-weight: 400;
  color: #1b1b1b;
`;

const LinkDivider = styled.div`
  margin: 0 0.5em;
  &:after {
    content: ' | ';
  }
`;

const LinkItem: React.FC<{ link: NavItem; isLast: boolean }> = (props) => (
  <>
    <Link {...props.link}>{props.link.label}</Link>
    {props.isLast ? null : <LinkDivider />}
  </>
);

const MinimalFooter: React.FC<FooterProps> = ({ isNavigable }) => {
  return (
    <FooterContainer>
      <FooterContentContainer>
        <FooterRow>
          <Copyright />
        </FooterRow>
        {isNavigable && (
          <FooterRow>
            {legalNavItems.map((link, i) => (
              <LinkItem key={i} link={link} isLast={legalNavItems.length - 1 === i} />
            ))}
          </FooterRow>
        )}
      </FooterContentContainer>
    </FooterContainer>
  );
};

export default MinimalFooter;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/types/MinimalFooter.tsx